import { Ref } from "vue";

export type FailureEvent = Map<string, string[]> | string;
export type FailureHandler = (failureEvent: FailureEvent) => void;
export default function userFailureHandler(
  failuresReceiver: Ref<Map<string, string[]>>
): FailureHandler {
  /**
   * Handles the failure event. Copies the values of failureEvent into
   * failure prop. It also re-emits the failure if emitFailures is given.
   */
  const onFailure = (failureEvent: FailureEvent) => {
    failuresReceiver.value.clear();
    if (failureEvent instanceof Map) {
      failureEvent.forEach((value, key) =>
        failuresReceiver.value.set(key, value)
      );
    } else {
      failuresReceiver.value.set("General", [failureEvent]);
    }
  };
  return onFailure;
}
